import React from 'react';
var VenueMapComponent = function VenueMapComponent(props) {
  var mapElement = props.mapElement;
  return /*#__PURE__*/React.createElement("div", {
    ref: mapElement,
    style: {
      height: '100%',
      width: '100%'
    }
  });
};
export default VenueMapComponent;